import { PlayerStateType } from './types';

import { PlayerActionType } from 'enums';
import { PlayerActionReturnType } from 'state/actions';

const initState: PlayerStateType = {
  isPlaying: false,
  startTime: 0,
  endTime: 0,
};

export const playerReducer = (
  // eslint-disable-next-line default-param-last
  state: PlayerStateType = initState,
  action: PlayerActionReturnType,
): PlayerStateType => {
  switch (action.type) {
    case PlayerActionType.SET_IS_PLAYING:
      return { ...state, isPlaying: action.isPlaying };
    case PlayerActionType.SET_START_TIME:
      return { ...state, startTime: action.startTime };
    case PlayerActionType.SET_END_TIME:
      return { ...state, endTime: action.endTime };
    default:
      return state;
  }
};
